import { useMutation, useQueryClient } from "@tanstack/react-query";

import { uploadCarbonProgramDraftContract } from "services";

import { GET_CARBON_PROGRAM_DRAFT, GET_CARBON_PROGRAM_DRAFTS, UPLOAD_CARBON_PROGRAM_DRAFT_CONTRACT } from "consts";

export const useUploadCarbonProgramDraftContract = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: [UPLOAD_CARBON_PROGRAM_DRAFT_CONTRACT],
    mutationFn: uploadCarbonProgramDraftContract,
    onSuccess: (draft) => {
      queryClient.invalidateQueries({ queryKey: [GET_CARBON_PROGRAM_DRAFTS] });
      queryClient.setQueryData([GET_CARBON_PROGRAM_DRAFT, draft.id], draft);
    },
  });
};
